import { render, staticRenderFns } from "./GovBannersView.vue?vue&type=template&id=4db1e2bd&scoped=true"
import script from "./GovBannersView.vue?vue&type=script&lang=ts"
export * from "./GovBannersView.vue?vue&type=script&lang=ts"
import style0 from "./GovBannersView.vue?vue&type=style&index=0&id=4db1e2bd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db1e2bd",
  null
  
)

export default component.exports